'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _urls = require('../utils/urls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (catalogId, coverLots, sellerId, featured, catalogUrl) {
    var _ref = coverLots || {},
        results = _ref.results;

    var _results = (0, _slicedToArray3.default)(results, 3),
        _results$ = _results[0],
        item1 = _results$ === undefined ? {} : _results$,
        _results$2 = _results[1],
        item2 = _results$2 === undefined ? {} : _results$2,
        _results$3 = _results[2],
        item3 = _results$3 === undefined ? {} : _results$3;

    var coverLotImgAlt1 = item1.title;
    var coverLotImgAlt2 = item2.title;
    var coverLotImgAlt3 = item3.title;

    var coverLotImgSrc1 = (0, _urls.getCoverLotPrimaryImageUrl)(sellerId, catalogId, item1.itemId, 1, item1.imageVersion, featured);
    var coverLotImgSrc2 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item2.itemId, 1, item2.imageVersion, featured);
    var coverLotImgSrc3 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item3.itemId, 1, item3.imageVersion, featured);

    var coverLotImgHref1 = void 0,
        coverLotImgHref2 = void 0,
        coverLotImgHref3 = void 0;
    if (catalogUrl) {
        coverLotImgHref1 = catalogUrl;
        coverLotImgHref2 = catalogUrl;
        coverLotImgHref3 = catalogUrl;
    } else {
        coverLotImgHref1 = (0, _urls.getItemUrl)(item1.itemId, item1.title);
        coverLotImgHref2 = (0, _urls.getItemUrl)(item2.itemId, item2.title);
        coverLotImgHref3 = (0, _urls.getItemUrl)(item3.itemId, item3.title);
    }

    return {
        primary: {
            imageAlt: coverLotImgAlt1,
            imageHref: coverLotImgHref1,
            imageSrc: coverLotImgSrc1
        },
        secondary1: {
            imageAlt: coverLotImgAlt2,
            imageHref: coverLotImgHref2,
            imageSrc: coverLotImgSrc2
        },
        secondary2: {
            imageAlt: coverLotImgAlt3,
            imageHref: coverLotImgHref3,
            imageSrc: coverLotImgSrc3
        }
    };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getCoverLotUrls.js
// module id = Jxk+
// module chunks = 57